<div class="broker-selector-dialog">
    <button mat-icon-button type="button" class="close-dialog-button" (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
    </button>
    <span class="dialog-title">
        Seleccionar agente
    </span>
    <span class="dialog-description">
        Por favor seleccione un agente de la lista.
    </span>
    <form class="filters" [formGroup]="filtersFG">
        <mat-form-field class="garantor-form-field no-bottom-spacing-form-field" appearance="outline">
            <mat-label>ID</mat-label>
            <input type="text" matInput formControlName="id">
            <button matSuffix mat-icon-button type="button" class="clear-filter-button" (click)="filtersFG.controls.id.setValue(undefined)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field class="garantor-form-field no-bottom-spacing-form-field" appearance="outline">
            <mat-label>CUIT</mat-label>
            <app-cuit-input formControlName="cuit"></app-cuit-input>
            <button matSuffix mat-icon-button type="button" class="clear-filter-button" (click)="filtersFG.controls.cuit.setValue('')">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field class="garantor-form-field no-bottom-spacing-form-field" appearance="outline">
            <mat-label>Oficina</mat-label>
            <mat-select formControlName="oficina" panelWidth="600px">
                <mat-option [value]="undefined">
                    Sin filtro
                </mat-option>
                <mat-option *ngFor="let office of offices" [value]="office">
                    {{ office.nombre }} - {{ office.sucursal }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" type="button" class="garantor-button mini apply-filters-button" (click)="paginatorStatus.itemsPerPage = 50; getBrokers()">
            Aplicar filtros
        </button>
    </form>
    <div class="broker-list" *ngIf="brokers && brokers.length">
        <div class="broker-card" *ngFor="let broker of brokers" (click)="cerrarDialogo(broker)">
            <div class="left">
                <span class="broker-name">
                    {{ broker.nombre }} {{ broker.apellido }}
                </span>
                <span class="broker-cuit">
                    CUIT: {{ utilsService.parseByType(broker.cuit, 'cuit') }}
                </span>
                <span class="broker-email">{{ broker.email }}</span>
            </div>
            <div class="right">
                <b>OFICINA</b>
                {{ broker.oficina.nombre }}
            </div>
        </div>
        <button mat-raised-button color="primary" type="button" class="garantor-button mini load-all-button" (click)="paginatorStatus.itemsPerPage = 100000; getBrokers()" *ngIf="paginatorStatus.totalElementCount > 30 && paginatorStatus.itemsPerPage === 30">
            Cargar todas
        </button>
    </div>
    <div class="empty" *ngIf="brokers && !brokers.length">
        No se encontraron agentes.
    </div>
</div>
